<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Comissionamento"
                @click.stop="abrirModalComissionamentoForm()"
                v-if="$temAcessoView('API-COMISSOES-02')"
            ></i>
        </span>
        <comissionamento-form
            @fecharModal="fecharModalComissionamentoForm()"
            @salvar="atualizarComissao($event)"
            :exibir="display"
            :comissionamento="comissao"
            :erros="erros"
            :contratos="contratos"
            acao="ATUALIZAÇÃO"
        ></comissionamento-form>
    </div>
</template>


<script>
import ComissionamentoForm from './ComissionamentoForm.vue'
import ComissionamentosServicos from './comissionamentosServicos'
import ContratosServicos from '../ContratosServicos'
export default {
    components: {
        ComissionamentoForm
    },

    props: {
        comissionamento: {
            type: Object,
            default: () => ({})
        }
    },

    emits: ['obterNovasComissoes'],

    data() {
        return {
            display: false,
            limpar: false,
            comissao: null,
            erros: [],
            contratos: []
        }
    },

    methods: {
        abrirModalComissionamentoForm() {
            this.display = true

            this.obterComissaoPorId()
            this.obterContratos()
        },
        fecharModalComissionamentoForm() {
            this.display = false
        },
        obterComissaoPorId() {
            this.$store.dispatch('addRequest')
            ComissionamentosServicos.obterComissaoPorId(
                this.$route.params.contratoId,
                this.comissionamento.comissaoId
            ).then((response) => {
                if (response && response.success) {
                    this.comissao = response.data
                } else {
                    this.erros = response.erros
                }
                this.$store.dispatch('removeRequest')
            })
        },
        atualizarComissao(data) {
            let comissaoAtualizacaoDto = {
                ContratoId: data.ContratoId,
                comissaoId: this.comissao.comissaoId,
                DataInicio: data.DataInicio,
                DataFinal: data.DataFinal,
                Recorrente: data.Recorrente,
                ContratoComissionadoId: data.ContratoComissionado,
                PorcentagemComissao: data.PorcentagemComissao,
                ContratoComissionadoId: data.ContratoComissionadoId
            }

            this.$store.dispatch('addRequest')

            ComissionamentosServicos.atualizarComissao(
                comissaoAtualizacaoDto
            ).then((response) => {
                if (response && response.success) {
                    this.$toast.success(
                        'Registro atualizado com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )

                    this.fecharModalComissionamentoForm()
                    this.$emit('obterNovasComissoes')
                } else {
                    this.erros = response.erros
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterContratos() {
            let filtro = {
                apenasAtivos: true
            }
            this.$store.dispatch('addRequest')
            ContratosServicos.obterTodos(filtro).then((response) => {
                if (response && response.success) {
                    this.contratos = response.data
                }
            })
            this.$store.dispatch('removeRequest')
        }
    }
}
</script>
